import {
  ActionDirection,
  ContainerTrainCarrier,
  ContainerTruckCarrier,
  PipeCarrier,
  ShipCarrier,
  ShipmentType,
  TrainCarrier,
  TruckCarrier
} from '@api/queries/inventory';
import React from 'react';
import ContainerTrain from './ContainerTrain';
import ContainerTruck from './ContainerTruck';
import Pipe from './Pipe';
import Ship from './Ship';
import Train from './Train';
import Truck from './Truck';

export interface ShipmentTypeFields {
  truck: TruckCarrier;
  train: TrainCarrier;
  ship: ShipCarrier;
  pipe: PipeCarrier;
  containerTrain: ContainerTrainCarrier;
  containerTruck: ContainerTruckCarrier;
}

interface Props extends ShipmentTypeFields {
  isDisabled?: boolean;
  shipmentType: ShipmentType;
  actionDirection: ActionDirection;
  onChange: (newValues: Partial<ShipmentTypeFields>) => void;
}

class ShipmentTypeDetails extends React.PureComponent<Props, any> {
  constructor(props) {
    super(props);
  }

  public render() {
    const {
      actionDirection,
      isDisabled,
      shipmentType,
      truck,
      train,
      ship,
      pipe,
      containerTrain,
      containerTruck
    } = this.props;
    const isAwayFromTerminal = actionDirection === ActionDirection.Outgoing;

    const renderShipmentDetails = () => {
      switch (shipmentType) {
        case ShipmentType.Truck:
          return (
            <Truck
              isDisabled={isDisabled}
              trafficOut={isAwayFromTerminal}
              truck={truck}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                this.handleChange('truck', e.target.name, e.target.value)
              }
            />
          );
        case ShipmentType.Train:
          return (
            <Train
              isDisabled={isDisabled}
              trafficOut={isAwayFromTerminal}
              train={train}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                this.handleChange('train', e.target.name, e.target.value)
              }
            />
          );
        case ShipmentType.Ship:
          return (
            <Ship
              isDisabled={isDisabled}
              trafficOut={isAwayFromTerminal}
              ship={ship}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                this.handleChange('ship', e.target.name, e.target.value)
              }
            />
          );
        case ShipmentType.Pipe:
          return (
            <Pipe
              isDisabled={isDisabled}
              trafficOut={isAwayFromTerminal}
              pipe={pipe}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                this.handleChange('pipe', e.target.name, e.target.value)
              }
            />
          );
        case ShipmentType.ContainerTrain:
          return (
            <ContainerTrain
              isDisabled={isDisabled}
              trafficOut={isAwayFromTerminal}
              containerTrain={containerTrain}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                this.handleChange('containerTrain', e.target.name, e.target.value)
              }
            />
          );
        case ShipmentType.ContainerTruck:
          return (
            <ContainerTruck
              isDisabled={isDisabled}
              trafficOut={isAwayFromTerminal}
              containerTruck={containerTruck}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                this.handleChange('containerTruck', e.target.name, e.target.value)
              }
            />
          );
        default:
          return null;
      }
    };

    return renderShipmentDetails();
  }

  private handleChange(entity: keyof ShipmentTypeFields, key, value) {
    this.props.onChange({
      [entity]: {
        ...this.props[entity],
        [key]: value
      }
    });
  }
}

export default ShipmentTypeDetails;
